import React, { useEffect, useState } from 'react'
import { Drawer } from '../drawer/drawer'
import { getEntry } from './audit-api'
import { AuditEntry } from './audit-entry'
import { auditErrorText } from './entry-format'
import { entryPath } from './record-links'
import { useAuditCapabilities } from './use-audit-capabilities'
import { ErrorReference } from '../error/error-reference'
import './audit.scss'

export { entryPath }

const NO_ACCESS = "You don't have access to this entry."
const GONE = "This entry isn't available. It may be older than the retention period, or not in your organization."

// One entry in the shared right-side slide-out (Drawer, the SSO workspace's
// .sw-drawer pattern), Details open. The permalink routes
// (/org|/admin/audit-log/entry/:id) open it; back = { label, onClick }
// returns to wherever it was opened from.
export const EntryDrawer = ({ entryID, onClose, back, sys = false, onPivot }) => {
  const caps = useAuditCapabilities()
  const [state, setState] = useState({ loading: true })

  useEffect(() => {
    if (!entryID) return undefined
    let live = true
    setState({ loading: true })
    // a super admin's entry may be in any organization (scope=all)
    const read = sys ? getEntry(entryID, { scope: 'all' }) : getEntry(entryID)
    read.then(
      e => live && setState(e ? { entry: e } : { gone: true }),
      err => {
        if (!live) return
        if (err && err.status === 403) setState({ error: auditErrorText(err, NO_ACCESS), failure: err })
        else if (err && err.status === 404) setState({ gone: true })
        else setState({ error: auditErrorText(err, "This entry couldn't be loaded."), failure: err })
      }
    )
    return () => {
      live = false
    }
  }, [entryID, sys])

  return (
    <Drawer open={Boolean(entryID)} title="Entry" onClose={onClose} back={back}>
      {state.loading && <p className="sw-hint m-0">Loading…</p>}
      {state.gone && <p className="m-0">{GONE}</p>}
      {state.error && <p className="text-danger small m-0" role="alert">{state.error}</p>}
      {state.error && <ErrorReference error={state.failure} />}
      {state.entry &&
        <ol className="au-tl">
          <AuditEntry entry={state.entry} detail={state.entry} sys={sys} caps={caps} onPivot={onPivot} open context="audit" />
        </ol>}
    </Drawer>
  )
}
